(function() {
  const originalFetch = window.fetch;
  window.fetch = function(url, options = {}) {
    if (typeof url === 'string' && url.includes('/apps/bss-b2b/checkout/create')) {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        console.warn('[BSS Emergency] Checkout create timed out after 3.5s -> Directing to native checkout');
        window.location.href = '/checkout';
      }, 3500);

      options.signal = controller.signal;
      return originalFetch(url, options)
        .then(res => {
          clearTimeout(timeoutId);
          return res;
        })
        .catch(err => {
          clearTimeout(timeoutId);
          if (err.name === 'AbortError') {
            window.location.href = '/checkout';
            return new Response(JSON.stringify({ success: false, errCode: 'TIMEOUT_FALLBACK' }), { status: 200 });
          }
          throw err;
        });
    }
    return originalFetch(url, options);
  };
})();


const moveTaxWrapper = () => {
  console.log('11111')
  const taxWrapper = document.querySelector('.bss-b2b-tax-ex-wrapper');
  const cartPageCol = document.querySelector('.cart__page-col:nth-child(2)');

  if (taxWrapper && cartPageCol && taxWrapper.parentElement !== cartPageCol) {
    cartPageCol.prepend(taxWrapper);
  }
};

moveTaxWrapper();

const observer = new MutationObserver(moveTaxWrapper);
observer.observe(document.body, {
  childList: true,
  subtree: true,
});